import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  Form,
  Card,
  Radio,
  Col,
  Row,
  message,
} from "antd";
import Service from "../../service";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import { useDispatch } from "react-redux";
import moment from "moment";
import HrmsLogo from "../../assets/images/HrmsLogo2.png";

const { TextArea } = Input;

const PreAppraisalForm = (props) => {
  const params_id = props.match?.params?.id || props.computedMatch?.params?.id;
  const [form] = Form.useForm();
  const [empApiData, setEmpApiData] = useState(null);
  const Logo = localStorage.getItem("LogoURL");
  const dispatch = useDispatch();
  const [responseData, setResponseData] = useState({});

  useEffect(() => {
    getEmployeeById();
  }, []);

  useEffect(() => {
    if (empApiData) {
      const formValues = {
        employee_name: empApiData.full_name || "-",
        department: empApiData?.department_id?.department_name || "-",
        designation: empApiData?.designation_id?.designation_name || "-",
        joining_date: empApiData?.joining_date
          ? moment(empApiData.joining_date).format("DD-MM-YYYY")
          : "-",
      };

      // Prefill pre-appraisal information if available
      if (empApiData.pre_appraisal_information) {
        const preAppraisalInfo = empApiData.pre_appraisal_information;
        formValues.new_skills_learned = preAppraisalInfo.new_skills_learned || "";
        formValues.challenges_overcome = preAppraisalInfo.challenges_overcome || "";
        formValues.key_achievements = preAppraisalInfo.key_achievements || "";
        formValues.team_impact = preAppraisalInfo.team_impact || "";
        formValues.professional_goals = preAppraisalInfo.professional_goals || "";
        formValues.goals_help_elsner = preAppraisalInfo.goals_help_elsner || "";
        formValues.team_collaboration_rating = preAppraisalInfo.team_collaboration_rating || "";
        formValues.positive_culture_contribution = preAppraisalInfo.positive_culture_contribution || "";
        formValues.overall_performance_rating = preAppraisalInfo.overall_performance_rating || "";
        formValues.training_development_needs = preAppraisalInfo.training_development_needs || "";
        formValues.work_life_balance = preAppraisalInfo.work_life_balance || "";
      }

      form.setFieldsValue(formValues);
    }
  }, [empApiData, form]);

  const handleSubmit = async (values) => {
    try {
      dispatch(showAuthLoader());

      const preAppraisalData = {
        // Section 2: Learning Growth
        new_skills_learned: values.new_skills_learned || "",
        challenges_overcome: values.challenges_overcome || "",
        
        // Section 3: Achievements
        key_achievements: values.key_achievements || "",
        team_impact: values.team_impact || "",
        
        // Section 4: Goals & Future Plans
        professional_goals: values.professional_goals || "",
        goals_help_elsner: values.goals_help_elsner || "",
        
        // Section 5: Team work & culture
        team_collaboration_rating: values.team_collaboration_rating || "",
        positive_culture_contribution: values.positive_culture_contribution || "",
        
        // Section 6: Self-Evaluation
        overall_performance_rating: values.overall_performance_rating || "",
        training_development_needs: values.training_development_needs || "",
        work_life_balance: values.work_life_balance || "",
      };

      const employeeId = empApiData?._id || params_id;
      const reqBody = {
        employee_id: employeeId,
        pre_appraisal_information: preAppraisalData,
      };

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.postPreAppraisalData,
        body: reqBody,
      });

      if (response.data && response.data.status == 200) {
        dispatch(hideAuthLoader());
        message.success(response.data.message);
        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        if (response.data) {
          setResponseData(response.data);
          if (response.data.status == 403) {
            // Already submitted
          } else {
            message.error(response.data.message);
          }
          dispatch(hideAuthLoader());
        }
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
      message.error("Failed to submit form. Please try again.");
    }
  };

  const getEmployeeById = async () => {
    try {
      dispatch(showAuthLoader());
      const params = `/${params_id}`;
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.preAppraisalApi + params,
      });

      if (response.data && response.data.data) {
        setEmpApiData(response.data.data);
        dispatch(hideAuthLoader());
      } else {
        if (response.data) {
          setResponseData(response.data);
          if (response.data.status == 403) {
            // Already submitted
          } else {
            message.error(response.data.message);
          }
          dispatch(hideAuthLoader());
        }
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
      message.error("Failed to load employee data.");
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 16 },
      lg: { span: 16 },
    },
  };

  return (
    <>
      <div className="gx-app-login-wrap account-login">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content feedback-form-div-first">
              <div className="gx-app-logo account_logo">
                {Logo ? (
                  <img alt="example" src={HrmsLogo} />
                ) : (
                  <img alt="example" src={HrmsLogo} />
                )}
              </div>
              <div className="gx-app-login-left-content">
                <h6>Welcome to Elsner HRMS Portal</h6>
              </div>
            </div>
            {responseData.status !== 403 && (
              <div className="gx-app-login-content feedback-form-div-second">
                <Card style={{ overflowX: "hidden", margin: "0" }}>
                  <div className="inout-header">
                    <h2>Pre-Appraisal Form</h2>
                  </div>
                  <Form
                    form={form}
                    className="feedback"
                    noValidate={true}
                    {...formItemLayout}
                    onFinish={handleSubmit}
                  >
                    {/* Basic Details Card */}
                    <Card
                      title="Basic Details"
                      style={{ marginBottom: 24 }}
                      bordered={false}
                    >
                      <Row gutter={16}>
                        <Col md={12} sm={24}>
                          <Form.Item
                            className="top-field"
                            label="Employee Name"
                            name="employee_name"
                            initialValue={
                              empApiData ? empApiData.full_name : "-"
                            }
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col md={12} sm={24}>
                          <Form.Item
                            label="Department"
                            name="department"
                            className="search-row top-field"
                            initialValue={
                              empApiData?.department_id?.department_name || "-"
                            }
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col md={12} sm={24}>
                          <Form.Item
                            label="Designation"
                            name="designation"
                            className="search-row top-field"
                            initialValue={
                              empApiData?.designation_id?.designation_name || "-"
                            }
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col md={12} sm={24}>
                          <Form.Item
                            label="Date of Joining (DOJ)"
                            name="joining_date"
                            className="search-row top-field"
                            initialValue={
                              empApiData?.joining_date
                                ? moment(empApiData.joining_date).format(
                                    "DD-MM-YYYY"
                                  )
                                : "-"
                            }
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>

                    {/* Section 2: Learning Growth */}
                    <Card
                      title="Section 2: Learning & Growth"
                      style={{ marginBottom: 24 }}
                      bordered={false}
                    >
                      <Form.Item
                        label="What new skills or knowledge have you learned in the past year?"
                        name="new_skills_learned"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                      <Form.Item
                        label="What challenges did you overcome that helped you grow?"
                        name="challenges_overcome"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                    </Card>

                    {/* Section 3: Achievements */}
                    <Card
                      title="Section 3: Achievements"
                      style={{ marginBottom: 24 }}
                      bordered={false}
                    >
                      <Form.Item
                        label="List your key achievements from the past year?"
                        name="key_achievements"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                      <Form.Item
                        label="How have your contributions impacted your team or Elsner?"
                        name="team_impact"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                    </Card>

                    {/* Section 4: Goals & Future Plans */}
                    <Card
                      title="Section 4: Goals & Future Plans"
                      style={{ marginBottom: 24 }}
                      bordered={false}
                    >
                      <Form.Item
                        label="What are your professional goals for the next year?"
                        name="professional_goals"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                      <Form.Item
                        label="How will these goals help Elsner grow?"
                        name="goals_help_elsner"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                    </Card>

                    {/* Section 5: Team work & culture */}
                    <Card
                      title="Section 5: Team Work & Culture"
                      style={{ marginBottom: 24 }}
                      bordered={false}
                    >
                      <Form.Item
                        label="How would you rate your collaborations with other teams?"
                        name="team_collaboration_rating"
                        rules={[
                          {
                            required: true,
                            message: "Please select a rating",
                          },
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={1}>1</Radio>
                          <Radio value={2}>2</Radio>
                          <Radio value={3}>3</Radio>
                          <Radio value={4}>4</Radio>
                          <Radio value={5}>5</Radio>
                        </Radio.Group>
                      </Form.Item>
                      <Form.Item
                        label="How have you contributed to a positive work culture?"
                        name="positive_culture_contribution"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                    </Card>

                    {/* Section 6: Self-Evaluation */}
                    <Card
                      title="Section 6: Self-Evaluation"
                      style={{ marginBottom: 24 }}
                      bordered={false}
                    >
                      <Form.Item
                        label="How would you rate your overall performance this year?"
                        name="overall_performance_rating"
                        rules={[
                          {
                            required: true,
                            message: "Please select a rating",
                          },
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={1}>1</Radio>
                          <Radio value={2}>2</Radio>
                          <Radio value={3}>3</Radio>
                          <Radio value={4}>4</Radio>
                          <Radio value={5}>5</Radio>
                        </Radio.Group>
                      </Form.Item>
                      <Form.Item
                        label="Training and Development Needs - What kind of training or support do you need from Elsner to improve yourself?"
                        name="training_development_needs"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Work-Life Balance & Wellbeing - How do you feel about your work-life balance?"
                        name="work_life_balance"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your response",
                          },
                        ]}
                      >
                        <TextArea
                          rows={6}
                          placeholder="Enter your response here..."
                          showCount={false}
                        />
                      </Form.Item>
                    </Card>

                    <Form.Item className="ant-col-xs-24 ant-col-sm-24 ant-col-lg-10 leavebtns">
                      <div className="add-leave-button">
                        <Button id="addbutton" type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </div>
                    </Form.Item>
                  </Form>
                </Card>
              </div>
            )}
            {responseData.status === 403 && (
              <div className="gx-app-login-content response-msg">
                <h2>{responseData.message}</h2>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PreAppraisalForm;

